
import { TimeOfDay } from "../types/form-types";

export const useSectionValidation = (
  title: string,
  preferredDates: Date[],
  preferredTimeOfDay: TimeOfDay[],
  locationType: 'specific' | 'flexible',
  preferredVenues: string[],
  locationNote: string,
) => {
  const isWhenSectionValid = preferredDates.length > 0 && preferredTimeOfDay.length > 0;
  const isWhereSectionValid = locationType === 'specific' ? preferredVenues.length > 0 : locationNote.trim().length > 0;
  const isDetailsSectionValid = title.trim().length > 0;
  const canGenerateDescription = isWhenSectionValid && isWhereSectionValid;

  return {
    isWhenSectionValid,
    isWhereSectionValid,
    isDetailsSectionValid,
    canGenerateDescription
  };
};
